// This is not a component that is initialized directly via the global
// component, but rather is initialized by the specific sponsorship pages. The
// normal sponsorship page will initialize this component using the init_page()
// function, and the sponsorship index page will initialize using the
// init_index() function.

// Local imports
import * as filtering from './filtering.js';
import * as filterMenus from './filterMenus.js';
import * as meet_child from './meetChild.js';
import * as topup from './topup.js';
import * as append_info from './appendInfo.js';

export function init_page(global) {
    topup.initialize(global);
}

export function init_index(global, custom_data, page_vars) {
    filtering.initialize(global, custom_data);
    filterMenus.initialize(global);
    meet_child.initialize(global);
    append_info.initialize(global, page_vars);
}
